import React, { Component } from "react";
// import { TabContent, TabPane, Nav, NavItem, NavLink, Col, Row, Button } from "reactstrap";
import { Link, Redirect } from "react-router-dom";
import Slider from "react-slick";
import "../assets/css/kiosk.css";

// import classnames from 'classnames';

import Modal from "react-responsive-modal";
// import { unstable_batchedUpdates } from "react-dom";
import { GetMain, ID_DESA } from "../function/Koneksi";
import { contactPerson } from "../function/get-data";

export default class Beranda7 extends Component {
  state = {
    paid: null,
    lisensi: null,
    loading: true,
    navigate: false,
    modalPanduan: false,
    modalPanduanLanjut: false,
    jenisPanduan: "",
    title: "",

    //Tab Pane
    active_tab_icon: "1"
  };

  logOut(e) {
    e.preventDefault();
    sessionStorage.removeItem("access_token");
    this.setState({ navigate: true });
  }

  // Bootstrap tabs function
  toggle_icon(tab) {
    if (this.state.active_tab_icon !== tab) {
      this.setState({
        active_tab_icon: tab
      });
    }
  }

  panduanLanjut = jenis => {
    if (jenis === "pembuatan-surat") {
      this.setState({
        title: "Panduan Pembuatan Surat",
        jenisPanduan: "pembuatan-surat"
      });
    } else if (jenis === "pendaftaran") {
      this.setState({
        title: "Panduan Pendaftaran",
        jenisPanduan: "pendaftaran"
      });
    } else if (jenis === "ubah-data") {
      this.setState({
        title: "Panduan Ubah Data",
        jenisPanduan: "ubah-data"
      });
    }
    this.setState({
      modalPanduan: false,
      modalPanduanLanjut: true
    });
    this.forceUpdate();
  };

  componentDidMount() {
    GetMain("main/web/list-layanan-desa", ID_DESA, data => {
      if (data.result) {
        if (data.result.data_api.data_invoice !== null) {
          let tgl = Date.now();
          let set_tgl = new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit"
          }).format(tgl);
          let ex_tgl = set_tgl.split("/");
          let hari_ini = ex_tgl[2] + "-" + ex_tgl[0] + "-" + ex_tgl[1];

          let expired = data.result.data_api.data_invoice.tgl_expired;
          let ex_tgl_expired = expired.split(" ");
          let tgl_expired = ex_tgl_expired[0];

          let set_hari_ini = new Date(hari_ini);
          let set_expired = new Date(tgl_expired);

          if (set_hari_ini.getTime() > set_expired.getTime()) {
            // Kondisi expired
            this.setState({
              lisensi: false
            });
          } else {
            // Kondisi belum expired
            this.setState({
              lisensi: true
            });
          }
        }

        let paid = false;
        if (data.result.pembayaran === 1) {
          paid = true;
        }

        this.setState({
          paid
        });

        setTimeout(
          function() {
            this.setState({
              loading: false
            });
          }.bind(this),
          1000
        );
      }
    });
  }

  render() {
    console.log("data render");
    console.log(this.state.paid);
    console.log(this.state.lisensi);

    const contact_person = contactPerson();

    let logoAplikasi = (
      <img
        src={require("../assets/images/logo-ld.webp").default}
        alt=""
        style={{ width: "auto", height: "70px" }}
      />
    );

    let folderAplikasi = localStorage.getItem("JENIS_APLIKASI").toLowerCase();
    if (folderAplikasi === "halaman kampung") {
      folderAplikasi = "digidesa";
    }

    switch (localStorage.getItem("JENIS_APLIKASI").toLowerCase()) {
      case "halaman kampung":
        logoAplikasi = (
          <img
            src={require("../assets/images/hk_icon.png")}
            alt=""
            style={{
              width: "auto",
              height: "70px"
            }}
          />
        );
        break;
      case "amanat nagari":
        logoAplikasi = (
          <img
            src={require("../assets/images/kiosk/amanat-nagari.png")}
            alt=""
            style={{
              width: "auto",
              height: "70px"
            }}
          />
        );
        break;
      default:
        logoAplikasi = (
          <img
            src={require("../assets/images/logo-ld.webp").default}
            alt=""
            style={{
              width: "auto",
              height: "70px"
            }}
          />
        );
        break;
    }

    const { navigate } = this.state;
    // //console.log(akun);
    if (navigate) {
      return <Redirect to="/" push={true} />;
    }

    const sliderStyle = {
      margin: "0px auto",
      width: "95%",
      // maxWidth: '1280px',
      maxWidth: "800px",
      // height: '357px',
      borderRadius: "21px",
      objectFit: "cover",
      objectPosition: "50% 50%"
    };

    var Merge_settings = {
      dots: true,
      infinite: true,
      speed: 100,
      slidesToShow: 1,
      slidesToScroll: 1,
      margin: 0,
      padding: 0
      // centerMode: true,
      // variableWidth: true,
      // adaptiveHeight:true,
    };

    if (this.state.loading) {
      return (
        <div className="row" style={{ height: "100vh", position: "relative" }}>
          <div
            className="col-sm-12"
            align="center"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)"
            }}
          >
            <img
              src={require("../assets/images/tes-loading.gif")}
              alt="loading"
              style={{
                // width: "100%",
                borderRadius: "10px",
                width: "150px",
                textAlign: "center"
              }}
            />
          </div>
        </div>
      );
    } else {
      return (
        <>
          <div className="kiosk-page-wrapper">
            <div className="kiosk-content-wrapper">
              {!this.state.paid ||
              (this.state.paid === null && this.state.lisensi === null) ? (
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="card mb-0">
                          <div
                            style={{ textAlign: "center", marginTop: "50px" }}
                          >
                            {logoAplikasi}
                          </div>
                          <div className="card-body datatable-react">
                            <img
                              src={require("../assets/images/banner/notif-join-us.jpg")}
                              alt=""
                              style={{
                                maxHeight: "250px",
                                width: "100%",
                                borderRadius: "10px"
                              }}
                            />
                            <br />
                            <br />
                            <br />
                            <p align="center">
                              <a href="/" onClick={this.logOut.bind(this)}>
                                <button className="btn btn-danger btn-square btn-sm pr-3 pl-3 pt-2 pb-2 mr-3">
                                  <i className="fa fa-arrow-left"></i> &nbsp;
                                  Kembali
                                </button>
                              </a>
                              <a href={contact_person.wa}>
                                <button className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">
                                  <i className="fa fa-whatsapp"></i> &nbsp;
                                  Hubungi Kami
                                </button>
                              </a>
                            </p>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              ) : this.state.paid && this.state.lisensi === null ? (
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="card mb-0">
                          <div
                            style={{ textAlign: "center", marginTop: "50px" }}
                          >
                            {logoAplikasi}
                          </div>
                          <div className="card-body datatable-react">
                            <img
                              src={require("../assets/images/banner/notif-config.jpg")}
                              alt=""
                              style={{
                                maxHeight: "250px",
                                width: "100%",
                                borderRadius: "10px"
                              }}
                            />
                            <br />
                            <br />
                            <br />
                            <p align="center">
                              <a href="/" onClick={this.logOut.bind(this)}>
                                <button className="btn btn-danger btn-square btn-sm pr-3 pl-3 pt-2 pb-2 mr-3">
                                  <i className="fa fa-arrow-left"></i> &nbsp;
                                  Kembali
                                </button>
                              </a>
                              <a href={contact_person.wa}>
                                <button className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">
                                  <i className="fa fa-whatsapp"></i> &nbsp;
                                  Hubungi Kami
                                </button>
                              </a>
                            </p>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              ) : this.state.paid && this.state.lisensi === false ? (
                <div>
                  <div className="container-fluid">
                    <div className="row">
                      <div className="col-sm-12">
                        <div className="card mb-0">
                          <div
                            style={{ textAlign: "center", marginTop: "50px" }}
                          >
                            {logoAplikasi}
                          </div>
                          <div className="card-body datatable-react">
                            <img
                              src={require("../assets/images/banner/notif-expired.jpg")}
                              alt=""
                              style={{
                                maxHeight: "250px",
                                width: "100%",
                                borderRadius: "10px"
                              }}
                            />
                            <br />
                            <br />
                            <br />
                            <p align="center">
                              <a href="/" onClick={this.logOut.bind(this)}>
                                <button className="btn btn-danger btn-square btn-sm pr-3 pl-3 pt-2 pb-2 mr-3">
                                  <i className="fa fa-arrow-left"></i> &nbsp;
                                  Kembali
                                </button>
                              </a>
                              <a href={contact_person.wa} target="_blank">
                                <button className="btn btn-primary-custom btn-square btn-sm pr-3 pl-3 pt-2 pb-2">
                                  <i className="fa fa-whatsapp"></i> &nbsp;
                                  Hubungi Kami
                                </button>
                              </a>
                            </p>
                            <br />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <br />
                </div>
              ) : (
                <>
                  <div className="row">
                    {/* title, login, panduan section */}
                    <div className="col-12 col-xl-6">
                      <div className="row">
                        {/* title */}
                        <div className="col-md-12 mb-4 mb-xl-2">
                          <div className="hero-text">
                            {logoAplikasi}
                            <div>
                              <span>
                                <b>SELAMAT DATANG DI</b>
                                <br />
                                <b> ANJUNGAN PELAYANAN MANDIRI </b>
                                <br />
                                <b>
                                  {localStorage
                                    .getItem("Nama_DESA")
                                    .toUpperCase()}
                                </b>
                              </span>
                            </div>
                          </div>
                        </div>
                          {/* login */}
                          <div className="col-md-12 text-center">
                            <Link to="/login-masyarakat">
                              <div className="hero-btn">
                                <img
                                  src={
                                    require("../assets/images/kiosk/masuk.png")
                                      .default
                                  }
                                  alt="kiosk login button"
                                  style={{
                                    height: "118px",
                                    width: "fit-content",
                                    maxWidth: "100%",
                                    borderRadius: "10px"
                                  }}
                                />
                                <span>MULAI</span>
                              </div>
                            </Link>
                          </div>
                        {/* panduan */}
                        {/* <div className="col-md-6">
                          <div className="hero-btn">
                            <img
                              src={
                                require("../assets/images/kiosk/panduan.png")
                                  .default
                              }
                              alt=""
                              style={{
                                height: "118px",
                                width: "fit-content",
                                maxWidth: "100%",
                                borderRadius: "10px"
                              }}
                              onClick={() => {
                                this.setState({
                                  modalPanduan: true
                                });
                                this.forceUpdate();
                              }}
                            />
                            <span>PANDUAN</span>
                          </div>
                          </Link>
                        </div> */}
                      </div>
                    </div>
                    {/* hero image*/}
                    <div className="col-12 col-xl-6 py-4 py-xl-0">
                      <div className="kiosk-image-container">
                        <img
                          src={require("../assets/images/kiosk/bg-kiosk-beranda.png")}
                          alt="gambar kiosk login"
                          className="h-100 w-100"
                          style={{
                            borderRadius: "20px",
                            objectFit: "contain"
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <Modal
            open={this.state.modalPanduan}
            // open={true}
            // open={true}
            onClose={false}
            styles={{
              modal: {
                width: "80%"
                // maxWidth: 'unset',
              }
            }}
            closeOnEsc={false}
            closeOnOverlayClick={false}
          >
            <div
              className="modal-body"
              style={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center"
              }}
            >
              <div className="row" style={{ textAlign: "center" }}>
                <h3>Panduan Penggunaan Layanan KiosK</h3>
              </div>

              <div className="row">
                <div
                  className="col-md-12"
                  onClick={() => this.panduanLanjut("pembuatan-surat")}
                >
                  <div>&nbsp;</div>
                  <div className="masuk">
                    <br />
                    <i
                      className="fa fa-clipboard fa-lg"
                      style={{ fontSize: "85px" }}
                    ></i>
                    <div>&nbsp;</div>
                    <div>
                      <span>Pembuatan Surat</span>
                    </div>
                  </div>
                </div>
                {/* <div className="col-md-4"
                  onClick={() => this.panduanLanjut("pendaftaran")}
                >
                    <div>
                      &nbsp;
                    </div>
                    <div className="keluar">
                      <br/>
                      <i className="fa fa-user-plus fa-lg" style={{ fontSize: '85px' }}></i>
                    <div>
                        &nbsp;
                    </div>
                    <div>
                      <span>Pendaftaran</span>
                    </div>
                    <div>
                        &nbsp;
                    </div>
                  </div>
                </div> */}
                {/* <div className="col-md-6"
                  onClick={() => this.panduanLanjut("ubah-data")}
                >
                    <div>
                      &nbsp;
                    </div>
                    <div className="keluar">
                      <br/>
                      <i className="fa fa-edit fa-lg" style={{ fontSize: '85px' }}></i>
                      <div>
                          &nbsp;
                      </div>
                      <div>
                        <span>Ubah Data</span>
                      </div>
                      <div>
                          &nbsp;
                      </div>
                    </div>
                </div> */}
              </div>

              {/* <Nav tabs className="tabs-color">
                <NavItem>
                  <NavLink className={classnames({ active: this.state.active_tab_icon === '1' })}
                    onClick={() => { this.toggle_icon('1'); }} >
                    <i className="icofont icofont-pay"></i>Membuat Surat
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: this.state.active_tab_icon === '2' })}
                    onClick={() => { this.toggle_icon('2'); }} >
                    <i className="icofont icofont-truck-alt"></i>Pendaftaran
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink className={classnames({ active: this.state.active_tab_icon === '3' })}
                    onClick={() => { this.toggle_icon('3'); }} >
                    <i className="icofont icofont-user"></i>Ubah Data
                  </NavLink>
                </NavItem>
              </Nav>
              */}
              {/* ===============================================================										 */}
              {/* <TabContent activeTab={this.state.active_tab_icon}>
                <TabPane tabId="1">
                  <div style={{ marginTop: 15 }}>
                    <Row>
                      <Col sm="12">
                        <br />

                        <div><br /><br /><h2 align="center">Jenis Pembayaran Desa</h2><hr /><br /><br /></div>

                      </Col>
                    </Row>

                  </div>
                </TabPane> */}

              {/* =========================================================================== */}
              {/* <TabPane tabId="2">
                  <div style={{ marginTop: 15 }}>
                    <Row>
                      <Col sm="12">
                        <br />
                        <div><br /><br /><h2 align="center">Jenis Pengiriman Desa</h2><hr /><br /><br /></div>
                      </Col>
                    </Row>

                  </div>
                </TabPane> */}

              {/* =========================================================================== */}
              {/* <TabPane tabId="3">
                  <div style={{ marginTop: 15 }}>
                    <Row>
                      <Col sm="12">
                        <br />
                        <div><br /><br /><h2 align="center">Jenis Pengiriman Desa</h2><hr /><br /><br /></div>
                      </Col>
                    </Row>

                  </div>
                </TabPane>
              </TabContent> */}
            </div>
            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <button
                onClick={() => {
                  this.setState({
                    modalPanduan: false
                  });
                  this.forceUpdate();
                }}
                className="btn btn-success"
              >
                Tutup
              </button>
            </div>
          </Modal>

          <Modal
            open={this.state.modalPanduanLanjut}
            onClose={() => {
              this.setState({ modalPanduanLanjut: false });
            }}
            styles={{
              modal: {
                width: "90%",
                maxWidth: "unset",
                maxHeight: "100%"
              }
            }}
            closeOnEsc={false}
            closeOnOverlayClick={false}
          >
            <div
              className="modal-body"
              style={
                {
                  // display: 'flex',
                  // justifyContent: 'center',
                  // flexDirection: 'column',
                  // alignItems: 'center'
                }
              }
            >
              <p
                style={{
                  textAlign: "center",
                  align: "center",
                  fontSize: "26px"
                }}
              >
                <b>{this.state.title}</b>
              </p>

              {this.state.jenisPanduan === "pembuatan-surat" ? (
                <Slider {...Merge_settings}>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={
                        require(`../assets/images/kiosk/panduan/${folderAplikasi}/cetaksurat/1.webp`)
                          .default
                      }
                      alt=""
                    />
                  </div>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={
                        require(`../assets/images/kiosk/panduan/${folderAplikasi}/cetaksurat/2.webp`)
                          .default
                      }
                      alt=""
                    />
                  </div>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={
                        require(`../assets/images/kiosk/panduan/${folderAplikasi}/cetaksurat/3.webp`)
                          .default
                      }
                      alt=""
                    />
                  </div>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={
                        require(`../assets/images/kiosk/panduan/${folderAplikasi}/cetaksurat/4.webp`)
                          .default
                      }
                      alt=""
                    />
                  </div>
                </Slider>
              ) : this.state.jenisPanduan === "pendaftaran" ? (
                <Slider {...Merge_settings}>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={require(`../assets/images/kiosk/panduan/${folderAplikasi}/pendaftaran/1.jpg`)}
                      alt=""
                    />
                  </div>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={require(`../assets/images/kiosk/panduan/${folderAplikasi}/pendaftaran/2.jpg`)}
                      alt=""
                    />
                  </div>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={require(`../assets/images/kiosk/panduan/${folderAplikasi}/pendaftaran/3.jpg`)}
                      alt=""
                    />
                  </div>
                </Slider>
              ) : this.state.jenisPanduan === "ubah-data" ? (
                <Slider {...Merge_settings}>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={require(`../assets/images/kiosk/panduan/${folderAplikasi}/ubahdata/1.jpg`)}
                      alt=""
                    />
                  </div>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={require(`../assets/images/kiosk/panduan/${folderAplikasi}/ubahdata/2.jpg`)}
                      alt=""
                    />
                  </div>
                  <div className="p-2">
                    <img
                      className="p-2"
                      style={sliderStyle}
                      src={require(`../assets/images/kiosk/panduan/${folderAplikasi}/ubahdata/3.jpg`)}
                      alt=""
                    />
                  </div>
                </Slider>
              ) : (
                <></>
              )}

              {/* <Slider {...Merge_settings}>
                {gambarList}
              </Slider> */}
            </div>
            <div
              className="modal-footer"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                paddingBottom: 0
              }}
            >
              <button
                onClick={() => {
                  this.setState({ modalPanduanLanjut: false });
                }}
                className="btn btn-success"
              >
                Tutup
              </button>
            </div>
          </Modal>
        </>
      );
    }
  }
}
